// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Terms$OrcaPaymentPage from "./Terms.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";
import * as SavedCardItem$OrcaPaymentPage from "./SavedCardItem.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as ShowMoreToggle$OrcaPaymentPage from "./ShowMoreToggle.bs.js";
import * as ApplePayHelpers$OrcaPaymentPage from "../Utilities/ApplePayHelpers.bs.js";
import * as GooglePayHelpers$OrcaPaymentPage from "../Utilities/GooglePayHelpers.bs.js";
import * as SwitchViewButton$OrcaPaymentPage from "./SwitchViewButton.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";
import * as SamsungPayHelpers$OrcaPaymentPage from "../Utilities/SamsungPayHelpers.bs.js";
import * as EligibilityHelpers$OrcaPaymentPage from "../Utilities/EligibilityHelpers.bs.js";
import * as SaveDetailsCheckbox$OrcaPaymentPage from "./SaveDetailsCheckbox.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./PaymentElementShimmer.bs.js";
import * as ClickToPayAuthenticate$OrcaPaymentPage from "./ClickToPayAuthenticate.bs.js";

function SavedMethods(props) {
  var cvcProps = props.cvcProps;
  var loadSavedCards = props.loadSavedCards;
  var savedMethods = props.savedMethods;
  var setPaymentToken = props.setPaymentToken;
  var paymentToken = props.paymentToken;
  var clickToPayConfig = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var clickToPayProvider = clickToPayConfig.clickToPayProvider;
  var customerMethods = Core__Option.getOr(clickToPayConfig.clickToPayCards, []).map(function (obj) {
        return PaymentType$OrcaPaymentPage.convertClickToPayCardToCustomerMethod(obj, clickToPayProvider);
      });
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var setShowPaymentMethodsScreen = match$1[1];
  var showPaymentMethodsScreen = match$1[0];
  var areRequiredFieldsValid = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var match$2 = React.useState(function () {
        return {};
      });
  var setRequiredFieldsBody = match$2[1];
  var requiredFieldsBody = match$2[0];
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var setUserError = function (message) {
    Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", message);
    loggerState.setLogError(message, "INVALID_FORMAT", undefined, undefined, undefined, undefined, undefined);
  };
  var match$3 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var alwaysSendCustomerAcceptance = match$3.alwaysSendCustomerAcceptance;
  var readOnly = match$3.readOnly;
  var savedPaymentMethodsCheckboxCheckedByDefault = match$3.savedPaymentMethodsCheckboxCheckedByDefault;
  var displaySavedPaymentMethodsCheckbox = match$3.displaySavedPaymentMethodsCheckbox;
  var match$4 = React.useState(function () {
        return savedPaymentMethodsCheckboxCheckedByDefault;
      });
  var isSaveCardsChecked = match$4[0];
  var isGuestCustomer = UtilityHooks$OrcaPaymentPage.useIsGuestCustomer();
  var match$5 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var iframeId = match$5.iframeId;
  var publishableKey = match$5.publishableKey;
  var sdkAuthorization = match$5.sdkAuthorization;
  var clientSecret = match$5.clientSecret;
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, undefined);
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var dict = Utils$OrcaPaymentPage.getDictFromJson(props.sessions);
  var sessionObj = React.useMemo((function () {
          return SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
        }), [dict]);
  var gPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Gpay");
  var applePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ApplePayObject");
  var applePayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(applePaySessionObj.sessionsToken, "ApplePay");
  var samsungPaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "SamsungPayObject");
  var samsungPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(samsungPaySessionObj.sessionsToken, "SamsungPay");
  var match$6 = React.useState(function () {
        return false;
      });
  var isClickToPayRememberMe = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setEligibilitySurchargeDetails = match$7[1];
  var eligibilitySurchargeDetails = match$7[0];
  var match$8 = React.useState(function () {
        return false;
      });
  var setIsEligibilityPending = match$8[1];
  var isEligibilityPending = match$8[0];
  var eligibilityControllerRef = React.useRef(undefined);
  var intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(loggerState, "Card");
  var savedCardlength = savedMethods.length;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var customerId = paymentToken.customerId;
  var paymentTokenVal = paymentToken.paymentToken;
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$3.layout);
  var match$9 = layoutClass.savedMethodCustomization.groupingBehavior;
  var groupByPaymentMethods = match$9.groupByPaymentMethods;
  var displayInSeparateScreen = match$9.displayInSeparateScreen;
  var groupSavedMethodsWithPaymentMethods = !displayInSeparateScreen && groupByPaymentMethods;
  var groupSavedMethodsSeparately = !displayInSeparateScreen && !groupByPaymentMethods;
  var maxItems = layoutClass.savedMethodCustomization.maxItems;
  var selectedOption = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var match$10 = React.useState(function () {
        
      });
  var setSelectedInstallmentPlan = match$10[1];
  var selectedInstallmentPlan = match$10[0];
  var match$11 = React.useState(function () {
        return false;
      });
  var setShowInstallments = match$11[1];
  var showInstallments = match$11[0];
  var match$12 = React.useState(function () {
        return true;
      });
  var isCollapsed = match$12[0];
  var shouldShowClickToPaySection = Caml_obj.equal(clickToPayConfig.isReady, true) && (!groupSavedMethodsWithPaymentMethods || selectedOption === "card");
  var match$13 = React.useState(function () {
        return "";
      });
  var setInstallmentsError = match$13[1];
  var installmentsError = match$13[0];
  var hasMoreSavedMethods = savedCardlength > maxItems;
  var visibleSavedMethods = hasMoreSavedMethods && isCollapsed ? savedMethods.slice(0, maxItems) : savedMethods;
  var bottomElement = React.createElement("div", {
        "aria-label": "Saved payment methods",
        className: "PickerItemContainer",
        role: "region",
        tabIndex: 0
      }, visibleSavedMethods.map(function (obj, i) {
            return JsxPPXReactSupportU.createElementWithKey(i.toString(), SavedCardItem$OrcaPaymentPage.make, {
                        setPaymentToken: setPaymentToken,
                        isActive: paymentTokenVal === obj.paymentToken,
                        paymentItem: obj,
                        brandIcon: CardUtils$OrcaPaymentPage.getPaymentMethodBrand(obj),
                        index: i,
                        savedCardlength: savedCardlength,
                        cvcProps: cvcProps,
                        setRequiredFieldsBody: setRequiredFieldsBody,
                        setSelectedInstallmentPlan: setSelectedInstallmentPlan,
                        showInstallments: showInstallments,
                        setShowInstallments: setShowInstallments,
                        installmentsError: installmentsError,
                        setInstallmentsError: setInstallmentsError,
                        eligibilitySurchargeDetails: paymentTokenVal === obj.paymentToken ? eligibilitySurchargeDetails : undefined
                      });
          }), React.createElement(RenderIf$OrcaPaymentPage.make, {
            condition: hasMoreSavedMethods,
            children: React.createElement(ShowMoreToggle$OrcaPaymentPage.make, {
                  isCollapsed: isCollapsed,
                  setIsCollapsed: match$12[1]
                })
          }), React.createElement(RenderIf$OrcaPaymentPage.make, {
            condition: shouldShowClickToPaySection,
            children: React.createElement(ClickToPayAuthenticate$OrcaPaymentPage.make, {
                  loggerState: loggerState,
                  savedMethods: savedMethods,
                  isClickToPayAuthenticateError: props.isClickToPayAuthenticateError,
                  setIsClickToPayAuthenticateError: props.setIsClickToPayAuthenticateError,
                  setPaymentToken: setPaymentToken,
                  paymentTokenVal: paymentTokenVal,
                  cvcProps: cvcProps,
                  getVisaCards: props.getVisaCards,
                  setIsClickToPayRememberMe: match$6[1],
                  closeComponentIfSavedMethodsAreEmpty: props.closeComponentIfSavedMethodsAreEmpty,
                  setSelectedInstallmentPlan: setSelectedInstallmentPlan,
                  showInstallments: showInstallments,
                  setShowInstallments: setShowInstallments,
                  installmentsError: installmentsError,
                  setInstallmentsError: setInstallmentsError
                })
          }));
  var setCvcError = cvcProps.setCvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCVCValid = cvcProps.isCVCValid;
  var complete = isCVCValid !== undefined ? paymentTokenVal !== "" && isCVCValid : false;
  var empty = cvcNumber === "";
  var customerMethod = React.useMemo((function () {
          return Core__Option.getOr(savedMethods.concat(customerMethods).filter(function (savedMethod) {
                            return savedMethod.paymentToken === paymentTokenVal;
                          })[0], PaymentType$OrcaPaymentPage.defaultCustomerMethods);
        }), [paymentTokenVal]);
  var isUnknownPaymentMethod = customerMethod.paymentMethod === "";
  var isCardPaymentMethod = customerMethod.paymentMethod === "card";
  var isCardPaymentMethodValid = !customerMethod.requiresCvv || complete && !empty;
  var isInstallmentValid = !showInstallments || Core__Option.isSome(selectedInstallmentPlan);
  var shouldDoEligibility = paymentMethodListValue.sdk_next_action === "eligibility_check";
  React.useEffect((function () {
          if (shouldDoEligibility && isCardPaymentMethod && paymentTokenVal !== "") {
            var eligibilityBody = [
              [
                "payment_method_type",
                "card"
              ],
              [
                "payment_token",
                paymentTokenVal
              ]
            ];
            EligibilityHelpers$OrcaPaymentPage.startEligibilityCheck(eligibilityControllerRef, clientSecret, publishableKey, loggerState, customPodUri, eligibilityBody, sdkAuthorization, endpoint, paymentMethodListValue.should_block_confirm, setIsEligibilityPending, setEligibilitySurchargeDetails, undefined, "Saved card payment eligibility check failed", (function (clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, signal) {
                    return PaymentHelpers$OrcaPaymentPage.fetchPaymentMethodEligibility(clientSecret, publishableKey, logger, customPodUri, bodyArr, Caml_option.some(sdkAuthorization), endpoint, Caml_option.some(signal));
                  }));
          } else {
            Core__Option.forEach(eligibilityControllerRef.current, (function (c) {
                    c.abort();
                  }));
            setEligibilitySurchargeDetails(function (param) {
                  
                });
            setIsEligibilityPending(function (param) {
                  return false;
                });
          }
          return (function () {
                    Core__Option.forEach(eligibilityControllerRef.current, (function (c) {
                            c.abort();
                          }));
                  });
        }), [
        paymentTokenVal,
        shouldDoEligibility,
        isCardPaymentMethod,
        clientSecret,
        publishableKey,
        sdkAuthorization,
        endpoint,
        customPodUri,
        paymentMethodListValue.should_block_confirm
      ]);
  var complete$1 = areRequiredFieldsValid && !isUnknownPaymentMethod && (!isCardPaymentMethod || isCardPaymentMethodValid) && isInstallmentValid && !isEligibilityPending;
  var paymentMethodType = Core__Option.getOr(customerMethod.paymentMethodType, customerMethod.paymentMethod);
  UtilityHooks$OrcaPaymentPage.useHandlePostMessages(complete$1, empty, paymentMethodType, true);
  GooglePayHelpers$OrcaPaymentPage.useHandleGooglePayResponse([], intent, true, undefined, undefined, sdkAuthorization);
  ApplePayHelpers$OrcaPaymentPage.useHandleApplePayResponse([], intent, undefined, undefined, undefined, true, undefined, undefined, sdkAuthorization);
  SamsungPayHelpers$OrcaPaymentPage.useHandleSamsungPayResponse(intent, true, undefined);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          var isCustomerAcceptanceRequired = alwaysSendCustomerAcceptance || !customerMethod.recurringEnabled || isSaveCardsChecked;
          var installmentBody = PaymentBody$OrcaPaymentPage.installmentBody(selectedInstallmentPlan);
          var match = customerMethod.paymentMethod;
          var savedPaymentMethodBody;
          if (match === "card") {
            savedPaymentMethodBody = PaymentBody$OrcaPaymentPage.savedCardBody(paymentTokenVal, customerId, cvcNumber, customerMethod.requiresCvv, isCustomerAcceptanceRequired).concat(installmentBody);
          } else {
            var paymentMethodType = customerMethod.paymentMethodType;
            var paymentMethodType$1 = paymentMethodType !== undefined && paymentMethodType !== "" ? paymentMethodType : null;
            savedPaymentMethodBody = PaymentBody$OrcaPaymentPage.savedPaymentMethodBody(paymentTokenVal, customerId, customerMethod.paymentMethod, paymentMethodType$1, isCustomerAcceptanceRequired);
          }
          if (!confirm.doSubmit) {
            return ;
          }
          if (customerMethod.card.isClickToPayCard) {
            Core__Promise.$$catch(ClickToPayHelpers$OrcaPaymentPage.handleProceedToPay(customerMethod.paymentToken, undefined, undefined, undefined, undefined, undefined, undefined, undefined, loggerState, undefined, clickToPayProvider, isClickToPayRememberMe, clickToPayConfig.clickToPayToken, Core__Option.getOr(clientSecret, ""), undefined).then(function (resp) {
                      var dict = Utils$OrcaPaymentPage.getDictFromJson(resp.payload);
                      var clickToPayBody;
                      switch (clickToPayProvider) {
                        case "VISA" :
                            clickToPayBody = PaymentBody$OrcaPaymentPage.visaClickToPayBody(Utils$OrcaPaymentPage.getString(dict, "checkoutResponse", ""), clickToPayConfig.email);
                            break;
                        case "MASTERCARD" :
                            var headers = Utils$OrcaPaymentPage.getDictFromDict(dict, "headers");
                            var merchantTransactionId = Utils$OrcaPaymentPage.getString(headers, "merchant-transaction-id", "");
                            var xSrcFlowId = Utils$OrcaPaymentPage.getString(headers, "x-src-cx-flow-id", "");
                            var correlationId = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "checkoutResponseData"), "srcCorrelationId", "");
                            clickToPayBody = PaymentBody$OrcaPaymentPage.mastercardClickToPayBody(merchantTransactionId, correlationId, xSrcFlowId);
                            break;
                        case "NONE" :
                            clickToPayBody = [];
                            break;
                        
                      }
                      intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(clickToPayBody.concat(installmentBody), requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                      return Promise.resolve(resp);
                    }), (function (param) {
                    return Promise.resolve({
                                status: "ERROR",
                                payload: null
                              });
                  }));
            return ;
          }
          if (complete$1 && confirm.confirmTimestamp >= confirm.readyTimestamp) {
            var match$1 = customerMethod.paymentMethodType;
            if (match$1 !== undefined) {
              switch (match$1) {
                case "apple_pay" :
                    if (applePayToken.TAG === "ApplePayTokenOptional") {
                      return ApplePayHelpers$OrcaPaymentPage.handleApplePayButtonClicked(applePayToken._0, componentName, paymentMethodListValue, true);
                    } else {
                      return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(savedPaymentMethodBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                    }
                case "google_pay" :
                    if (gPayToken.TAG === "OtherTokenOptional") {
                      return GooglePayHelpers$OrcaPaymentPage.handleGooglePayClicked(gPayToken._0, componentName, iframeId, readOnly, true);
                    } else {
                      return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(savedPaymentMethodBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                    }
                case "samsung_pay" :
                    if (samsungPayToken.TAG === "SamsungPayTokenOptional") {
                      return SamsungPayHelpers$OrcaPaymentPage.handleSamsungPayClicked(Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(samsungPayToken._0, null)), componentName, iframeId, readOnly, true);
                    } else {
                      return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(savedPaymentMethodBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                    }
                default:
                  
              }
            }
            return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(savedPaymentMethodBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
          }
          if (isEligibilityPending && paymentMethodListValue.should_block_confirm) {
            setUserError(localeString.paymentDetailsBeingCheckedText);
          }
          if (isUnknownPaymentMethod || confirm.confirmTimestamp < confirm.readyTimestamp) {
            setUserError(localeString.selectPaymentMethodText);
          }
          if (customerMethod.requiresCvv) {
            if (!isUnknownPaymentMethod && cvcNumber === "") {
              setCvcError(function (param) {
                    return localeString.cvcNumberEmptyText;
                  });
              setUserError(localeString.enterFieldsText);
            } else if (!Core__Option.getOr(isCVCValid, false)) {
              setCvcError(function (param) {
                    return localeString.inCompleteCVCErrorText;
                  });
              setUserError(localeString.enterValidDetailsText);
            }
            
          }
          if (!areRequiredFieldsValid) {
            setUserError(localeString.enterValidDetailsText);
          }
          if (!isInstallmentValid) {
            setUserError(localeString.installmentSelectPlanError);
            return setInstallmentsError(function (param) {
                        return localeString.installmentSelectPlanError;
                      });
          }
          
        }), [
        areRequiredFieldsValid,
        requiredFieldsBody,
        empty,
        complete$1,
        customerMethod,
        applePayToken,
        gPayToken,
        isManualRetryEnabled,
        selectedInstallmentPlan,
        showInstallments,
        sdkAuthorization,
        isEligibilityPending
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  var conditionsForShowingSaveCardCheckbox = React.useMemo((function () {
          if (!isGuestCustomer && paymentMethodListValue.payment_type === "NEW_MANDATE" && displaySavedPaymentMethodsCheckbox) {
            return customerMethod.requiresCvv;
          } else {
            return false;
          }
        }), [
        isGuestCustomer,
        paymentMethodListValue.payment_type,
        displaySavedPaymentMethodsCheckbox,
        customerMethod
      ]);
  var showSavedCards = groupSavedMethodsSeparately || !showPaymentMethodsScreen;
  var enableSavedPaymentShimmer = React.useMemo((function () {
          if (savedCardlength === 0 && !showPaymentMethodsScreen) {
            if (loadSavedCards === "LoadingSavedCards") {
              return true;
            } else {
              return Core__Option.isNone(clickToPayConfig.isReady);
            }
          } else {
            return false;
          }
        }), [
        savedCardlength,
        loadSavedCards,
        showPaymentMethodsScreen,
        clickToPayConfig.isReady
      ]);
  return React.createElement("div", {
              className: "flex flex-col overflow-auto h-auto no-scrollbar animate-slowShow"
            }, enableSavedPaymentShimmer ? React.createElement(PaymentElementShimmer$OrcaPaymentPage.SavedPaymentCardShimmer.make, {}) : React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: showSavedCards,
                    children: bottomElement
                  }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: isEligibilityPending && paymentMethodListValue.should_block_confirm,
                  children: React.createElement("div", {
                        className: "flex items-baseline text-xs mt-2"
                      }, React.createElement("div", {
                            className: "text-left text-gray-400"
                          }, localeString.paymentDetailsBeingCheckedText))
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: conditionsForShowingSaveCardCheckbox && !alwaysSendCustomerAcceptance,
                  children: React.createElement("div", {
                        className: "pt-4 pb-2 flex items-center justify-start"
                      }, React.createElement(SaveDetailsCheckbox$OrcaPaymentPage.make, {
                            isChecked: isSaveCardsChecked,
                            setIsChecked: match$4[1]
                          }))
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: alwaysSendCustomerAcceptance || displaySavedPaymentMethodsCheckbox && paymentMethodListValue.payment_type === "SETUP_MANDATE",
                  children: React.createElement(Terms$OrcaPaymentPage.make, {
                        styles: {
                          marginTop: match.themeObj.spacingGridColumn
                        },
                        paymentMethod: "card",
                        paymentMethodType: "debit"
                      })
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !enableSavedPaymentShimmer && !groupSavedMethodsSeparately,
                  children: React.createElement(SwitchViewButton$OrcaPaymentPage.make, {
                        onClick: (function (param) {
                            setShowPaymentMethodsScreen(function (param) {
                                  return true;
                                });
                          }),
                        icon: React.createElement(Icon$OrcaPaymentPage.make, {
                              name: "circle-plus",
                              size: 22
                            }),
                        title: localeString.newPaymentMethods,
                        ariaLabel: "Click to use new payment methods",
                        onKeyDown: (function ($$event) {
                            var key = $$event.key;
                            var keyCode = $$event.keyCode;
                            if (key === "Enter" || keyCode === 13) {
                              return setShowPaymentMethodsScreen(function (param) {
                                          return true;
                                        });
                            }
                            
                          }),
                        dataTestId: TestUtils$OrcaPaymentPage.addNewCardIcon
                      })
                }));
}

var make = SavedMethods;

export {
  make ,
}
/* react Not a pure module */
